import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['container']

  connect() {
    if (this.data.has("id")) {
      const hubspotFormId = this.data.get("id")
      this.containerTarget.id = `hsform-${hubspotFormId}`
      this.createForm(hubspotFormId)
    }

    document.addEventListener('turbolinks:before-cache', () => {
      this.containerTarget.innerHTML = ''
      }, {once: true}
    )
  }

  createForm(hubspotFormId) {
    if (typeof hbspt !== 'undefined') {
      hbspt.forms.create({
        region: "na1",
        portalId: "4854285",
        formId: hubspotFormId,
        target: `#hsform-${hubspotFormId}`
      })
    } else {
      setTimeout(this.createForm, 100, hubspotFormId)
    }
  }
}
